import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { WellHeaderInfoService } from 'app/modules/well-header-information/services/well-header-info.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { noWhitespaceValidator } from 'app/core/shared/helper/form.helper';
import module from "app/modules/well-header-information/well-header-information.module";

@Component({
  selector: 'app-add-well-modal',
  templateUrl: './add-well-modal.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: module,
  styleUrls: ['./add-well-modal.component.scss']
})
export class AddWellModalComponent {
  public wellForm: FormGroup
  public isSuccess: boolean = false
  public isLoading: boolean = false

  constructor(
    public dialogRef: MatDialogRef<AddWellModalComponent>,
    private wellHeaderInfoService : WellHeaderInfoService,
    @Inject(MAT_DIALOG_DATA) public platformId: any,
    private fb: FormBuilder,
    public dialog: MatDialog,
  ) {}

  ngOnInit(){
    this.wellForm = this.initializeForm()

    this.wellForm.get('wellShortName')?.valueChanges.subscribe(value => {
      if (value && value !== value.toUpperCase()) {
        this.wellForm.get('wellShortName')?.setValue(value.toUpperCase(), { emitEvent: false });
      }
    });
  }

  initializeForm(){
    return this.fb.group({
      platformId: this.platformId,
      wellShortName: ['', [Validators.required, noWhitespaceValidator()]],
      wellLongName: ['', [Validators.required, noWhitespaceValidator()]],
      wellStatus: '',
      latitude: 0,
      longitude: 0,
      uwi: '',
      slotNumber: '',
      remarks: '',
    })
  }

  createWells(){
    this.wellHeaderInfoService.createWells(this.wellForm.value).subscribe((res)=>{
      if(res.isSuccess){
        this.isSuccess = true
        this.closeDialog()
      }
    })
  }

  closeDialog(): void {
    this.dialogRef.close(this.isSuccess);
  }

  get wellLongName() {
    return this.wellForm.get('wellLongName');
  }

  get wellShortName() {
    return this.wellForm.get('wellShortName');
  }
}
